export default {"src":"/_next/static/image/public/images/ic_video_upload_doc.c3fa2345d1f8dcc1605ba8582c3e934c.svg","height":56,"width":56};